module.exports = __webpack_public_path__ + "img/end-call.b38f13f1.svg";